(function () {
	// Sensitivity multiplier: higher value = faster scroll per pixel drag
	const DRAG_SENSITIVITY = 1.5; // np. 3 = przesunięcie 60px daje scroll 180px
	const carousels = document.querySelectorAll('.simplest-carousel, .is-style-simplest-carousel');

	// Width of a single item including the gap (distance between item starts).
	function getItemStep(carousel) {
		const items = carousel.querySelectorAll(':scope > .simplest-carousel__item');
		if (items.length >= 2) {
			return items[1].offsetLeft - items[0].offsetLeft;
		}
		return items.length ? items[0].offsetWidth : carousel.clientWidth;
	}

	carousels.forEach(carousel => {
		let isDown = false;
		let startX = 0;
		let scrollLeft = 0;
		let dragMoved = false;
		const DRAG_THRESHOLD = 5; // px of movement before it counts as a drag (not a click)

		carousel.querySelectorAll(':scope > *').forEach(child => {
			child.classList.add('simplest-carousel__item');
			child.querySelectorAll('img').forEach(img => {
				img.setAttribute('draggable', 'false');
			});
		});

		// Arrows ----------------------------------------------------------------
		if (carousel.classList.contains('carousel-arrows')) {
			const wrapper = document.createElement('div');
			wrapper.className = 'simplest-carousel__wrapper';
			carousel.parentNode.insertBefore(wrapper, carousel);
			wrapper.appendChild(carousel);

			const arrows = document.createElement('div');
			arrows.className = 'simplest-carousel__arrows';

			const prev = document.createElement('div');
			prev.className = 'simplest-carousel__arrow arrow--prev';

			const next = document.createElement('div');
			next.className = 'simplest-carousel__arrow arrow--next';

			arrows.appendChild(prev);
			arrows.appendChild(next);
			wrapper.appendChild(arrows);

			prev.addEventListener('click', () => {
				carousel.scrollBy({ left: -getItemStep(carousel), behavior: 'smooth' });
			});
			next.addEventListener('click', () => {
				carousel.scrollBy({ left: getItemStep(carousel), behavior: 'smooth' });
			});

			function updateArrowsVisibility() {
				const hasOverflow = carousel.scrollWidth > carousel.clientWidth + 1;
				arrows.style.display = hasOverflow ? '' : 'none';
			}

			updateArrowsVisibility();
			window.addEventListener('resize', updateArrowsVisibility);
		}


		carousel.addEventListener('mousedown', (e) => {
			isDown = true;
			dragMoved = false;
			carousel.classList.add('is-dragging');
			startX = e.pageX;
			scrollLeft = carousel.scrollLeft;
			document.body.style.userSelect = 'none';
		});
		// Prevent native drag of links/images (ghost element following the cursor).
		carousel.addEventListener('dragstart', (e) => {
			e.preventDefault();
		});
		// Suppress the click that fires after a drag, so dragging doesn't open the link.
		carousel.addEventListener('click', (e) => {
			if (dragMoved) {
				e.preventDefault();
				e.stopPropagation();
				dragMoved = false;
			}
		}, true);
		carousel.addEventListener('mouseleave', () => {
			isDown = false;
			carousel.classList.remove('is-dragging');
			document.body.style.userSelect = '';
		});
		// Remove carousel mouseup
		// Attach mouseup to window for reliable detection
		window.addEventListener('mouseup', () => {
			if (isDown) {
				isDown = false;
				carousel.classList.remove('is-dragging');
				document.body.style.userSelect = '';
			}
		});
		carousel.addEventListener('mousemove', (e) => {
			if (!isDown) return;
			e.preventDefault();
			const x = e.pageX;
			if (Math.abs(x - startX) > DRAG_THRESHOLD) {
				dragMoved = true;
			}
			const scroll = (x - startX) * DRAG_SENSITIVITY;
			carousel.scrollLeft = scrollLeft - scroll;
		});
		// Obsługa dotyku na mobile
		carousel.addEventListener('touchstart', (e) => {
			isDown = true;
			startX = e.touches[0].pageX;
			scrollLeft = carousel.scrollLeft;
		});
		carousel.addEventListener('touchend', () => {
			isDown = false;
		});
		carousel.addEventListener('touchmove', (e) => {
			if (!isDown) return;
			const x = e.touches[0].pageX;
			const scroll = (x - startX) * DRAG_SENSITIVITY;
			carousel.scrollLeft = scrollLeft - scroll;
		});
	});
})();
